import React, { PureComponent } from 'react';
import { withEditorState } from './EditorStateContext';
import { selectAtomicBlock, isBlockFocused } from '../utilities/blockUtilities';

class AtomicSelect extends PureComponent {
    focusBlock = () => {
        const { block, setEditorState, editorState } = this.props;
        selectAtomicBlock(block, setEditorState, editorState);
    };

    render() {
        const {
            readOnly,
            children,
            block,
            editorState,
        } = this.props;

        if (!editorState) {
            return children;
        }

        const selection = editorState.getSelection();

        const isFocused = isBlockFocused(readOnly, block, selection);
        const className = isFocused ? 'atomic-select block-focused' : 'atomic-select';

        return (
            // eslint-disable-next-line
            <div className={className} onClick={this.focusBlock}>
                {children}
            </div>
        );
    }
}

export default withEditorState(AtomicSelect);
